import { EditShiftPlanningFormData, ShiftPlanningViewModel } from '../../../models'
import { formatDate, parseTime } from '../../helpers/date'
import { transformToPeriod } from '../Period/PeriodTransformers'
import { ShiftPlanning } from '../ShiftPlanning/ShiftPlanning'
import { transformShiftPlanningUser } from '../User/UserTransformers'
import {
    BaseScheduleShiftPlanningDetail,
    BaseScheduleShiftPlanningDetailResource,
    BaseScheduleShiftPlanningV3Resource,
    CreateBaseScheduleShiftPlanningRequest,
    PatchBaseScheduleShiftPlanningRequest,
} from './BaseScheduleShiftPlanning'

export const transformBaseScheduleShiftPlanning = (resource: BaseScheduleShiftPlanningV3Resource): ShiftPlanning => ({
    id: resource.uuid,
    type: 'shiftPlanning',
    color: resource.color,
    period: transformToPeriod(
        parseTime(resource.start ?? '00:00'),
        parseTime(resource.end ?? '00:00'),
    ),
    customStartTime: resource.hasCustomTime,
    planned: true,
    comments: [],
    user: transformShiftPlanningUser(resource.user),
})

export const transformBaseScheduleShiftPlanningDetail = (
    resource: BaseScheduleShiftPlanningDetailResource,
): BaseScheduleShiftPlanningDetail => ({
    id: resource.uuid,
    baseScheduleShiftId: resource.baseScheduleShiftUuid,
    hasCustomTime: resource.hasCustomTime,
    start: resource.start,
    end: resource.end,
    color: resource.color,
    user: resource.user,
})

export const transformAddBaseScheduleShiftPlanningToV3Request = (
    baseScheduleShiftId: string,
    userId: string,
): CreateBaseScheduleShiftPlanningRequest => ({
    baseScheduleShiftUuid: baseScheduleShiftId,
    userUuid: userId,
    color: null,
})

export const transformBaseScheduleShiftPlanningToV3CopyRequest = (
    shiftPlanning: ShiftPlanningViewModel,
    baseScheduleShiftId: string,
): CreateBaseScheduleShiftPlanningRequest => ({
    baseScheduleShiftUuid: baseScheduleShiftId,
    userUuid: shiftPlanning.user?.id || '',
    start: formatDate(shiftPlanning.start, 'HH:mm'),
    end: formatDate(shiftPlanning.end.date, 'HH:mm'),
    color: shiftPlanning.color || null,
})

export const transformEditBaseScheduleShiftPlanningFormDataToV3PatchRequest = (
    formData: EditShiftPlanningFormData,
): PatchBaseScheduleShiftPlanningRequest => ({
    start: formData.startTime,
    end: formData.endTime,
})

export const transformEditBaseScheduleShiftPlanningColorToV3PatchRequest = (
    color?: string,
): PatchBaseScheduleShiftPlanningRequest => ({
    color: color || null,
})
